import { render, staticRenderFns } from "./managersDca.vue?vue&type=template&id=087d611a&"
import script from "./managersDca.vue?vue&type=script&lang=js&"
export * from "./managersDca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports